/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  class FAQFilteringHandler {
    constructor() {
      (this.faqSections = [...document.querySelectorAll("[data-faq-heading]")]),
        (this.accordions = [
          ...document.querySelectorAll("[data-faq-content]"),
        ]),
        this.faqSections.length && this._init();
    }
    _init() {
      this._setInitialState();

      this.faqSections.forEach((e) => {
        const t = e.getAttribute("data-faq-heading");
        e.addEventListener("click", () => {
          this._hideAccordions();
          this._showAccordions(t);
        });
      });
    }
    _setInitialState() {
      const e = this.faqSections[0].getAttribute("data-faq-heading");
      this._showAccordions(e);
    }
    _showAccordions(e) {
      [...document.querySelectorAll(`[data-faq-content="${e}"]`)].forEach(
        (e) => {
          e.classList.remove("hidden");
        }
      );
    }
    _hideAccordions() {
      this.accordions.forEach((e) => {
        e.classList.add("hidden");
      });
    }
  }

  const sizeGuideListHandler = {
    modal: document.getElementById("sizeGuideModal"),
    modalBtns: [...document.querySelectorAll(".size-guide-modal-btn")],
    modalBtn: document.getElementById("sizeGuideModalBtn"),
    closeBtn: document.getElementById("guide-list__close"),
    init() {
      if (this.modalBtns.length && this.modal) {
        const closeElements = [this.modal, this.closeBtn];

        this.modalBtns.forEach((btn) => {
          btn.onclick = (e) => {
            console.log(btn);
            this.modal.style.display = "flex";
            document.body.style.overflow = "hidden";
          };
        });

        closeElements.forEach((element) => {
          element.onclick = (e) => {
            this.modal.style.display = "none";
            document.body.style.overflow = "";
          };
        });
      }
    },
  };

  function dominantColorLazyLoading() {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazy");
      var imageObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove("lazy");
            imageObserver.unobserve(image);
          }
        });
      });

      lazyloadImages.forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazy");

      function lazyload() {
        if (lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function () {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function (img) {
            if (img.offsetTop < window.innerHeight + scrollTop) {
              img.src = img.dataset.src;
              img.classList.remove("lazy");
            }
          });
          if (lazyloadImages.length == 0) {
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }

      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  }

  // const checkoutCheckbox = {
  //   checkbox: document.getElementById("agreeCheckout"),
  //   button: document.getElementById("checkoutSubmitBtn"),
  //   init() {
  //     if (this.checkbox && this.button) {
  //       console.log(this.checkbox);
  //       console.log(this.button);
  //       this.checkbox.addEventListener("change", () => {
  //         this.button.disabled = !this.checkbox.checked;
  //       });
  //     }
  //   },
  // };

  const externalLinkHandler = {
    links: [...document.querySelectorAll("a")],
    init() {
      this.links.forEach((link) => {
        if (link.host !== window.location.hostname) {
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noreferrer noopener");
        }
      });
    },
  };

  const blogSearch = {
    showSearchBtn: document.getElementById("show-blog-search"),
    searchForm: document.getElementById("blog-search-form"),
    init() {
      if (this.showSearchBtn && this.searchForm) {
        console.log(this.showSearchBtn);
        console.log(this.searchForm);

        this.showSearchBtn.addEventListener("click", () => {
          console.log("Search was clicked");
          this.searchForm.style.display = "block";
          this.showSearchBtn.style.display = "none";
        });
      }
    },
  };

  document.addEventListener("DOMContentLoaded", () => {
    new FAQFilteringHandler();
    sizeGuideListHandler.init();
    externalLinkHandler.init();
    blogSearch.init();
    dominantColorLazyLoading();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
